module.exports = __webpack_public_path__ + "static/media/22769834_1629547150453803_2210882702659285496_o.6d54a5ee.jpg";